var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6298_148270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5948 22.7825H3.40406C2.22427 22.7825 1.12838 22.1716 0.508168 21.1679C-0.112224 20.1643 -0.16864 18.911 0.359069 17.8556L8.95443 3.13969C9.53123 1.98646 10.7099 1.25781 11.9994 1.25781C13.2889 1.25781 14.4676 1.98646 15.0444 3.13969L23.6398 17.8556C24.1675 18.911 24.1111 20.1643 23.4907 21.1679C22.8705 22.1716 21.7748 22.7825 20.5948 22.7825Z",
    fill: "#F0C419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5969 22.7826H11.9995V1.25788C13.2921 1.24982 14.4756 1.98139 15.0462 3.1414L23.6393 17.8568C24.1678 18.9115 24.1121 20.1647 23.4922 21.1683C22.8722 22.1721 21.7767 22.7829 20.5969 22.7826Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6551 19.057C13.6551 19.9716 12.9137 20.7129 11.9993 20.7129C11.0849 20.7129 10.3436 19.9716 10.3436 19.057C10.3436 18.1426 11.0849 17.4014 11.9993 17.4014C12.9137 17.4014 13.6551 18.1426 13.6551 19.057Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6553 19.057C13.6553 19.4963 13.481 19.9174 13.1705 20.228C12.8598 20.5385 12.4387 20.7129 11.9995 20.7129V17.4014C12.4387 17.4012 12.8598 17.5756 13.1705 17.8862C13.481 18.1967 13.6553 18.618 13.6553 19.057Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 4.56934C12.9137 4.56934 13.6551 5.31062 13.6551 6.22518V14.0899C13.6551 15.0043 12.9137 15.7455 11.9993 15.7455C11.0849 15.7455 10.3436 15.0043 10.3436 14.0899V6.22518C10.3436 5.31062 11.0849 4.56934 11.9993 4.56934Z",
    fill: "#35495E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6553 6.22518V14.0899C13.6553 14.5291 13.481 14.9502 13.1705 15.2607C12.8598 15.5714 12.4387 15.7457 11.9995 15.7456V4.56934C12.4387 4.56879 12.8604 4.74298 13.1711 5.05363C13.4815 5.36429 13.6559 5.78576 13.6553 6.22518Z",
    fill: "#2C3E50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6298_148270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.1123c58a1c9f7740a54f2c86e7a31edb.svg";
export { ForwardRef as ReactComponent };